import React from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { LookInsideCarousel } from './components/LookInsideCarousel';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { MoreResults } from './components/MoreResults';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { Testimonials } from './components/Testimonials';
import { UrgencySection } from './components/UrgencySection';
export function App() {
  return <div className="min-h-screen w-full overflow-hidden bg-background font-sans text-muted antialiased" data-id="element-0" data-mp="3mlja0y7k5j4n">
      <MetaPixel data-id="element-1" data-mp="3rc9co3oln7vn" />
      <main data-id="element-2" data-mp="3rbrc4uuwm7hx">
        <Hero data-id="element-3" data-mp="3rdapodp6e4g0" />
        <Testimonials data-id="element-4" data-mp="3rdkkqfp2v1sk" />
        <LookInsideCarousel data-id="element-5" data-mp="3recd7hndojem" />
        <ProblemSection data-id="element-6" data-mp="5orh0l86u6j" />
        <SystemSection data-id="element-7" data-mp="4wv3njt0sf7" />
        <ModulesSection data-id="element-8" data-mp="5gbv0xpxarn" />
        <BonusSection data-id="element-9" data-mp="7st1bvnjh3n" />
        <UrgencySection data-id="element-10" data-mp="2zllf11m4wkmq" />
        <PricingSection data-id="element-11" data-mp="2zm4xqkjlzd1t" />
        <MoreResults data-id="element-12" data-mp="2zmwguvw0rib7" />
        <GuaranteeSection data-id="element-13" data-mp="2znfyebhrc4op" />
        <FAQ data-id="element-14" data-mp="33m5bs42spm8c" />
        <ClosingSection data-id="element-15" data-mp="33nq6put0v76q" />
        <SummaryTable data-id="element-16" data-mp="33mym1f0yqtv8" />
        <FinalCta data-id="element-17" data-mp="33oi1x4ipj2wh" />
      </main>
      <Footer data-id="element-18" data-mp="38l8eviz7tido" />
      <PurchaseNotification data-id="element-19" data-mp="38kqbm2e4y3w9" />
    </div>;
}